import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="loader-indicator"
export default class extends Controller {
  connect() {
    // Show loader for navigations and form submissions
    document.addEventListener(
      "turbo:before-fetch-request",
      this.handleTurboRequest
    );
    document.addEventListener("click", this.handleNavigation);
    document.addEventListener("submit", this.handleNavigation);

    // Hide loader when navigation or Turbo Stream completes
    document.addEventListener("turbo:load", this.hideLoader);
    document.addEventListener("turbo:frame-load", this.hideLoader);
    document.addEventListener("turbo:fetch-end", this.hideLoader);
    document.addEventListener("turbo:submit-end", this.hideLoader);
    document.addEventListener("turbo:fetch-request-error", this.hideLoader);
    window.addEventListener("pageshow", this.hideLoader);
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-fetch-request",
      this.handleTurboRequest
    );
    document.removeEventListener("click", this.handleNavigation);
    document.removeEventListener("submit", this.handleNavigation);
    document.removeEventListener("turbo:load", this.hideLoader);
    document.removeEventListener("turbo:frame-load", this.hideLoader);
    document.removeEventListener("turbo:fetch-end", this.hideLoader);
    document.removeEventListener("turbo:submit-end", this.hideLoader);
    document.removeEventListener("turbo:fetch-request-error", this.hideLoader);
    window.removeEventListener("pageshow", this.hideLoader);
  }

  handleTurboRequest = (event) => {
    let target = event.target;
    if (target && target.tagName === "TURBO-FRAME") return; // skip frame requests
    this.showLoader();
  };

  handleNavigation = (event) => {
    let element =
      event.type === "click"
        ? event.target.closest("a")
        : event.target.closest("form");

    if (!element || !this.willCauseNavigation(element)) return;
    this.showLoader();
  };

  willCauseNavigation(element) {
    if (element.tagName === "A") {
      const href = element.getAttribute("href");

      if (element.dataset.loader === "false") return false;

      return (
        href &&
        !href.startsWith("#") &&
        !href.startsWith("javascript:") &&
        !href.startsWith("mailto:") &&
        !href.startsWith("tel:") &&
        !element.hasAttribute("download") &&
        element.getAttribute("target") !== "_blank"
      );
    }

    if (element.tagName === "FORM") {
      if (element.querySelector("[data-turbo-confirm]")) return false;

      return !element.hasAttribute("data-remote");
    }

    return false;
  }

  showLoader = () => {
    const loader = document.getElementById("global-loader");
    if (loader) loader.style.display = "flex";
  };

  hideLoader = () => {
    const loader = document.getElementById("global-loader");
    if (loader) loader.style.display = "none";
  };
}
